import { Icon } from "@shopify/polaris";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "reactstrap";
import { actFecthModalCharge, actFecthModalYearlyPlan, actFecthModalYearlyPlanEnhance } from "../../../actions";
import { CircleTickMinor, MobileCancelMajor } from "@shopify/polaris-icons";
import callApi from "../../../utils/apiCaller";
import Swal from "sweetalert2";
import pluswhite from "./svg/pluswhite.svg";
import plusyellow from "./svg/plusyellow.png";

const modalConfig = [
	{
		id: "pro_plus",
		plan: "PRO PLUS",
		normally: 240,
		current: 120,
		limit: "20,000",
		stores: 3,
		link: "",
	},
	{
		id: "unlimited",
		plan: "UNLIMITED",
		normally: 420,
		current: 210,
		limit: "Unlimited",
		stores: 4,
		link: "",
	},
];

const YearlyPlanModal = () => {
	const { commonSetting, dataSettings } = useSelector((state) => state);
	const { modalYearlyPlanEnhance } = commonSetting;
	// console.log(modalYearlyPlan);
	const dispatch = useDispatch();

	const handleYearlyPlan = (plan) => {
		let paramsClick = {
			action: "clickReview",
			type: "click_upgrade",
			note: "campain_yearly_jan",
		};
		callApi("get", paramsClick).then(async (res) => {});

		let params = {
			action: "activePlan",
			type: plan,
			subscription: "annually",
			dayProcess: 0,
			is_campaign: 1,
		};

		callApi("get", params).then((res) => {
			if (res.data.state === 2) {
				Swal.fire({
					icon: "success",
					title: "Successfully",
					text: res.data.msg,
					showCloseButton: false,
					showConfirmButton: false,
					timer: 3000,
				}).then((result) => {
					window.location.reload();
					//   console.log("test");
				});
			} else {
				window.top.location.replace(res.data.confirmation_url);
			}
		});
		// dispatch(actFecthModalYearlyPlan(false));
		// dispatch(actFecthModalCharge(true));
	};

	return (
    <>
      <Modal
        isOpen={modalYearlyPlanEnhance}
        toggle={() =>
          dispatch(actFecthModalYearlyPlan(!modalYearlyPlanEnhance))
        }
        centered
        // backdrop="static"
        scrollable={true}
        className="st-yearly-plan-modal-wrap"
      >
        <div className="st-yearly-plan-modal">
          <div
            className="st-yearly-close"
            onClick={() =>
              dispatch(actFecthModalYearlyPlanEnhance(!modalYearlyPlanEnhance))
            }
          >
            <Icon
              source={MobileCancelMajor}
              color="base"
            />
          </div>
          <div className="st-yearly-plan-modal-body">
            {modalConfig.map((item, index) => (
              <div
                className="yearly-card"
                key={index}
              >
                <div className="yearly-card-title">
                  <h1>{item.plan}</h1>
                </div>
                <div className="yearly-card-content">
                  <div className="yearly-card-normally">
                    <span className="text-grey">normally ${item.normally}</span>
                  </div>
                  <div className="yearly-card-current">
                    <span>$</span>
                    <b>{item.current}</b>
                  </div>
                  <span className="text-grey">per year</span>
                  <br />
                  <button
                    onClick={() => handleYearlyPlan(item.id)}
                    style={{ cursor: "pointer" }}
                  >
                    Buy
                  </button>
                  <div className="yearly-card-footer">
                    <div>
                      <Icon
                        source={CircleTickMinor}
                        color="primary"
                      />
                      <div>
                        <b>{item.limit} </b>
                        <span>synced orders/month</span>
                      </div>
                    </div>
                    <div>
                      <Icon
                        source={CircleTickMinor}
                        color="primary"
                      />
                      <div>
                        <b>{item.stores} stores </b>
                        <span> for Multi-store intergration</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="st-yearly-plan-modal-gradient">
            <img
              src={pluswhite}
              className="position-absolute right-0 top-30 w-10"
            />
            <img
              src={pluswhite}
              className="position-absolute w-10 left-5"
            />
            <img
              src={plusyellow}
              className="position-absolute right-7 top-5 w-6"
            />
            <img
              src={plusyellow}
              className="position-absolute w-6 top-30"
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default YearlyPlanModal;
